// Auth context contract shared by the dev and password providers: mode, session status, sign-in (the password answers the two-step sign-in step that follows, or null once signed in), the session hand-over after the code, the authenticator setup, a reset or an accepted invitation, sign-out and the session-check error.
import { createContext, use } from "react";

import type { Me, SignInStep } from "@/api/__generated__";

export type AuthMode = "dev" | "password";
export type AuthStatus = "loading" | "authenticated" | "unauthenticated";

export interface Credentials {
  email: string;
  password: string;
}

export interface AuthState {
  mode: AuthMode;
  status: AuthStatus;
  signedOut: boolean;
  checkError: unknown;
  signIn: (credentials?: Credentials) => Promise<SignInStep | null>;
  startSession: (me: Me) => void;
  signOut: () => Promise<void>;
  recheck: () => void;
}

function settle(): Promise<void> {
  return Promise.resolve();
}

function signedIn(): Promise<SignInStep | null> {
  return Promise.resolve(null);
}

export const INITIAL_AUTH: AuthState = {
  mode: "dev",
  status: "loading",
  signedOut: false,
  checkError: null,
  signIn: signedIn,
  startSession: () => undefined,
  signOut: settle,
  recheck: () => undefined,
};

export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const context = use(AuthContext);
  if (context === null) {
    throw new Error("useAuth must be used inside AuthProvider.");
  }
  return context;
}
